import { useEffect, useMemo, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions, GradeLevelOptions, GradeOptions, getGradeOptions } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/level-sections/LevelSectionsAction";
import { useLevelSectionsUIContext } from "../LevelSectionsUIContext";

const prepareFilter = (queryParams, values) => {
  let { gradeLevel, grade, name, capacity, courseId } = values;
  capacity = capacity === "" ? null : capacity;
  const newQueryParams = { ...queryParams };
  const filter = { gradeLevel, grade, name, capacity, courseId };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function LevelSectionsFilter() {
  // Level Sections UI Context
  const levelSectionsUIContext = useLevelSectionsUIContext();
  const levelSectionsUIProps = useMemo(() => {
    return {
      setQueryParams: levelSectionsUIContext.setQueryParams,
      queryParams: levelSectionsUIContext.queryParams,
    };
  }, [levelSectionsUIContext]);
  
  const [gradeOptions, setGradeOptions] = useState(FilterOptions.concat(GradeOptions));
  
  const dispatch = useDispatch();
  const { courses } = useSelector(
    (state) => ({
      courses: state.levelSections.courses
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getCourses());
  }, [dispatch]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(levelSectionsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, levelSectionsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      levelSectionsUIProps.setQueryParams(newQueryParams);
    }
  };

  const gradeLevelOptions = FilterOptions.concat(GradeLevelOptions);
  const courseOptions = FilterOptions.concat(courses);

  return (
    <Formik
      initialValues={{
        name: "",
        capacity: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <CustomSelect 
                options={gradeLevelOptions}
                value={values.gradeLevel}
                placeholder="Sınıf Düzeyi"
                onBlur={handleBlur}
                onChange={e => {
                  if (e.value === undefined) {
                    setGradeOptions(FilterOptions.concat(GradeOptions));
                    setFieldValue("grade", undefined);

                  } else {
                    const options = getGradeOptions(e.value);

                    if (options.length === 1) {
                      setGradeOptions(options);
                      setFieldValue("grade", options[0].value);

                    } else {
                      setGradeOptions(FilterOptions.concat(options));
                      if (!options.map(option => option.value).includes(values.grade)) setFieldValue("grade", undefined);
                    }
                  }            
                  setFieldValue("gradeLevel", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıf Düzeyi</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={gradeOptions}
                value={values.grade}
                placeholder="Kur Sınıfı"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("grade", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kur Sınıfı</b>
              </small>
            </div>            
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Kur"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kur</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="capacity"
                min={1}
                placeholder="Kapasite"
                onBlur={handleBlur}
                value={values.capacity}
                onChange={(e) => {
                  setFieldValue("capacity", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kapasite</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={courseOptions}
                value={values.courseId}
                placeholder="Ders"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("courseId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Ders</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}